import loadable from '@loadable/component';

const SignUp = loadable(
  () => import(/* webpackChunkName: "SignUpComponents" */ './components'),
  {
    resolveComponent: module => module.Router,
  },
);

export { SignUp };
